import { useState } from "react";
import Quotes from "../../Quotes";
import CreateQuoteForm from "./CreateQuoteForm";

const VIEWS = {
  NEW: "new",
  LEGACY: "legacy",
};

export default function QuotesWrapper() {
  const [activeView, setActiveView] = useState(VIEWS.LEGACY);

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="">
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-6">
          <aside className="col-span-1">
            <div className="sticky top-8 space-y-3">
              <h3 className="text-sm font-medium text-gray-900 mb-2">Views</h3>

              <button
                type="button"
                onClick={() => setActiveView(VIEWS.LEGACY)}
                className={`flex flex-col items-start w-full text-left px-4 py-2 rounded-md border transition ${
                  activeView === VIEWS.LEGACY
                    ? "bg-white border-gray-300 shadow-sm"
                    : "bg-transparent border-transparent hover:bg-white hover:border-gray-200"
                }`}
              >
                <div className="text-sm font-semibold text-gray-900">Legacy</div>
                <div className="text-xs text-gray-500">Use legacy quote generation</div>
              </button>

              <button
                type="button"
                onClick={() => setActiveView(VIEWS.NEW)}
                className={`flex flex-col items-start w-full text-left px-4 py-2 rounded-md border transition ${
                  activeView === VIEWS.NEW
                    ? "bg-white border-gray-300 shadow-sm"
                    : "bg-transparent border-transparent hover:bg-white hover:border-gray-200"
                }`}
              >
                <div className="text-sm font-semibold text-gray-900">New Quote Form</div>
                <div className="text-xs text-gray-500">
                  Full quote builder with preview
                </div>
              </button>
            </div>
          </aside>

          {/* Content area */}
          <main className="col-span-1 lg:col-span-5">
            {activeView === VIEWS.NEW ? (
              <div>
                <CreateQuoteForm />
              </div>
            ) : (
              <div>
                <Quotes />
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
